import { Controller, useForm } from "react-hook-form";
import { Modal, Button, Alert, FormRow } from 'components/common';
import TinymceEditor from "components/common/TinymceEditor";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PropTypes from 'prop-types';
import { FaBan, FaPlus, FaSave } from "react-icons/fa";
import { INPUT_CLS } from "helpers/formStyles";

const FORM_ID = "add-change-form";

const AddChangeForm = ({
  showModal,
  setshowModal,
  building,
  descriptionChanges,
  setDescriptionChanges,
  descriptionChange
}) => {
  const {control, register, handleSubmit, formState: {errors}, setValue} = useForm();
  const [title, setTitle] = useState("Add some changes for building!");

  useEffect(() => {
    //for case edit
    if (descriptionChange) {
      setTitle(`Edit description change with change No.#${descriptionChange.change_no}`)

      Object.entries(descriptionChange).forEach(([key, value]) => {
        setValue(key, value)
      })
    }
  }, [building, descriptionChange, setValue])

  const closeModal = () => {
    setshowModal(false)
  }

  const handleCancel = () => {
    closeModal()
  }

  const onSubmit = (data) => {
    //deal_proj_id: building.id

    //for case edit
    // Validate change_no uniqueness
    const isDuplicate = descriptionChanges.some(item =>
      item.change_no === data.change_no &&
      (!descriptionChange || item.change_no !== descriptionChange.change_no)
    );

    if (isDuplicate) {
      toast.error(`Change no#${data.change_no} already exists. Please use a unique Change No.`);
      return;
    }

    if (descriptionChange) {
      const updatedDescriptionChanges = descriptionChanges.map(item =>
        item.change_no === descriptionChange.change_no ? { ...item, ...data } : item
      );

      setDescriptionChanges(updatedDescriptionChanges);
      toast.success(`Change no#${data.change_no} updated.`);
      closeModal();
    } else {
      // Stamp the creation time so the read-only table can show when each change
      // was added. Edits keep the original (the form has no created_at input, so
      // `data` never carries one over the existing row).
      const newDataItem = { ...data, deal_proj_id: building.id, created_at: new Date().toISOString() };
      setDescriptionChanges([...descriptionChanges, newDataItem]);
      toast.success(`Change no#${data.change_no} created.`);
    }
  }

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      title={title}
      size="full"
      backdropClick={false}
      footer={
        <>
          <Button
            type="submit"
            form={FORM_ID}
            variant="primary"
            size="sm"
            leftIcon={descriptionChange ? FaSave : FaPlus}
          >
            {descriptionChange ? "Update" : "Add"} change
          </Button>
          <Button variant="danger" size="sm" leftIcon={FaBan} onClick={handleCancel}>
            Close
          </Button>
        </>
      }
    >
      <form id={FORM_ID} onSubmit={handleSubmit(onSubmit)}>
        <Alert type="warning" className="tw-mb-4">
          Specify information and create a list of buildings slated for modifications.
        </Alert>

        <FormRow label="Bldg No." error={errors.building_name?.message}>
          <input
            type="text"
            placeholder="Building"
            className={INPUT_CLS}
            defaultValue={building.name}
            readOnly={true}
            {...register("building_name", {
              required: "Building must be required."
            })}
          />
        </FormRow>

        <FormRow label="Change No." error={errors.change_no?.message}>
          <input
            type="number"
            placeholder="Change No."
            className={INPUT_CLS}
            {...register("change_no")}
          />
        </FormRow>

        <FormRow label="Description of changes" error={errors.description?.message}>
          <Controller
            control={control}
            name="description"
            rules={{required: "Description of changes must be required."}}
            render={({ field }) => (
              <TinymceEditor
                handleChange={field.onChange}
                value={field.value}
              />
            )}
          />
        </FormRow>
      </form>
    </Modal>
  )
};

AddChangeForm.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired,
  building: PropTypes.object.isRequired,
  descriptionChanges: PropTypes.object.isRequired,
  setDescriptionChanges: PropTypes.func.isRequired,
  descriptionChange: PropTypes.object.isRequired
}

export default AddChangeForm;
